module.exports = "https://static.zego.com/_next/static/images/SpeechMark-7da368ade88d613048ebe3cc9b8a5680.svg";